"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const Button_1 = require("../Button");
exports.ButtonSwitch = ({ activeIcon = react_1.default.createElement(fa_1.FaCheck, null), inactiveIcon = react_1.default.createElement(fa_1.FaTimes, null), activeType = "primary", inactiveType = "dark", activeTitle, inactiveTitle, checked, iconRight, onChange, className, ...rest }) => {
    return (react_1.default.createElement(Button_1.Button, Object.assign({ onClick: onChange, type: checked ? activeType : inactiveType, title: checked ? activeTitle : inactiveTitle, icon: checked ? activeIcon : inactiveIcon }, rest)));
};
